import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PatientAllergy, PatientAllAllergyList } from '../../models/patient-facesheet/patient-allergy.model';
import { HttpBaseService } from '../http-base.service';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { AuthService } from '@service/auth.sevice';
import { AuthTokenHelper } from '@helpers/auth-token-helper';

@Injectable()
export class PatientAllergyService {
  private readonly API_URL = 'assets/data/patient-allergy.json';
  public apiURL = '';
  dataChange: BehaviorSubject<PatientAllergy[]> = new BehaviorSubject<PatientAllergy[]>([]);
  // Temporarily stores data from dialogs
  dialogData: any;
  decryptedTokenValue: string;
  
  constructor(private httpClient: HttpClient, private httpService: HttpBaseService, private helper?: BeyondEMRHelper,
    private decryptToken?: AuthService,
    private authValue?: AuthTokenHelper,) { }

  get data(): PatientAllergy[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllPatientAllergyHistorys(): void {
    this.httpClient.get<PatientAllergy[]>(this.apiURL).subscribe(
      data => {
        return this.dataChange.next(data);
      },
      (error: HttpErrorResponse) => {
        console.log(error.name + ' ' + error.message);
      }
    );
  }

  addPatientAllergy(patientAllergy: PatientAllergy): void {
    // patientAllergy.PatientId = (this.decryptedTokenValue == 'Patient' ? this.helper?.decodedId() : patientAllergy.PatientId) as number;
    this.dialogData = patientAllergy;
    console.log(this.dialogData)
    this.getAPIURL();
    this.httpService.post(this.apiURL + "patientallergy/Create", patientAllergy, true).subscribe(response => {
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }

  ngOnInit() {
    let tokendetail = (this.authValue.GetAuthorizationTokenValue());
    this.decryptedTokenValue = this.decryptToken.getDecodedAccessToken(tokendetail).UserRole;
}

  updatePatientAllergy(patientAllergy: PatientAllergy): void {
    this.dialogData = patientAllergy;
    this.getAPIURL();
    this.httpService.post(this.apiURL + "patientallergy/Edit", patientAllergy, true).subscribe(response => {
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }

  getAPIURL(): void {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
    });
  }

  deletePatientAllergy(id: number): void {
    console.log(id);
  }
}

